<template>
  <div class="margin-neg">
    <b-row>
      <b-col sm="2" md="2" style="padding-bottom: 1rem">
        <b-button style="position:absolute; bottom:1rem; left:12px;"
                  v-on:click="$emit('create-definition')"
                  variant="success"
                  class="px-4 mr-3 mt-auto">Definition anlegen
        </b-button>
      </b-col>
      <b-col sm="2" md="2" style="padding-bottom: 1rem">
        <b-button style="position:absolute; bottom:1rem; left:12px;"
                  v-on:click="$emit('open-settings')"
                  variant="success"
                  class="px-4 mr-3 mt-auto">Einstellungen
        </b-button>
      </b-col>
      <b-col sm="2" md="1">
        <b-form-group
        ><div style="z-index: 20; cursor:pointer">
          <b-form-select id="bh_zu_in"
                         style="background: white; visibility: hidden"
                         disabled
                         size="sm">
          </b-form-select>
        </div>
        </b-form-group>
      </b-col>
      <b-col>
      </b-col>
      <b-col sm="2" md="2" class="ml-auto" style="padding-bottom: 1rem"
             v-on:keypress.enter="searchText">
        <b-form-input
            style="position:absolute; bottom:1rem; left:0;"
            v-model="fullTextSearch"
            placeholder="Suche"></b-form-input>
      </b-col>
      <b-col sm="2" md="1" style="padding-bottom: 1rem">
        <b-button style="position:absolute; bottom:1rem; left:12px;"
                  v-on:click="searchText"
                  variant="primary"
                  class="px-4 mr-3 mt-auto">Suchen
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    onSearch: {
      type: Function,
      default: undefined
    },
  },
  name: "DefinitionSearchbar",
  computed: {
  },
  data: () => {
    return {
      fullTextSearch: "",
      wasMounted: false,
    }
  },
  methods: {
    searchText() {
      if (this.onSearch !== undefined) {
        this.onSearch(
            this.fullTextSearch)
      }
    },
    searchFilter() {
      if (this.onSearch !== undefined) {
        this.onSearch(
            this.fullTextSearch)
      }
    },
    onFirstSearch() {
      this.wasMounted = true;
    },
    setQuery({searchText}) {
      this.fullTextSearch = searchText;
    },
  },
  watch: {
  }
}
</script>

<style scoped>

::v-deep .btn.active > .calendar-item {
  color: black;
  border-color: black;
}
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}
.ic-chevron {
  color: #696969;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px;
}
::v-deep .material-design-icon > .material-design-icon__svg {
  bottom: inherit;
}

::v-deep .refresh-icon > .material-design-icon__svg {
  bottom: auto !important;
}

::v-deep .btn.btn-secondary {
  background: white;
  cursor: pointer;
}
.calendar-item {
  height: 1.5rem;
  width: 1.5rem;
  position: inherit;
  vertical-align: middle;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  align-self: center;
  color: #696969;
}

.filter-active {
  background-color: #018a33 !important;
  border-color: #02411b !important;
  color: white !important;
}

::v-deep .tree-icon.none {
  display: none;
}

::v-deep .month-picker-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  color: black;
  font-weight: 400;
  border: 1px solid #c0c0c0;
  width: 100%;
  height: 26px;
}

::v-deep .month-picker-input-container {
  height: 26px;
  margin-top: 0.5rem;
  width: 60%;
}

::v-deep .month-picker__container {
  z-index: 100;
}
</style>

<style>
.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}

</style>
